import { Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { editTracking } from "services/data.internal.service";
import { LoadingDialog } from "ui-components/Alert";
import { Success, Error_ } from "ui-components/Alert";
import { FormTitle } from "ui-components/Form";
import { Texts } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
function EditTracking() {
  const { customerCode } = useCustomerValue();
  const [form, setForm] = useState({ custOrdNbr: "", trackingNumber: "", awbLink: "" });
  const [alert, setAlert] = useState(null);
  const editMutation = useMutation(editTracking, {});
  const onSuccess = (data) => {
    setForm({ custOrdNbr: "", trackingNumber: "", awbLink: "" });
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);

  const canSubmit =
    Boolean(form.custOrdNbr) && Boolean(form.trackingNumber) && Boolean(form.awbLink);
  const onSubmit = () => {
    const req = { customerCode, ...form };
    editMutation.mutate(req, { onSuccess, onError });
  };
  const editStatus = editMutation.status === "loading";
  return (
    <Layout>
      {alert}
      {editStatus && <LoadingDialog/>}
      <FormTitle title={"Update Order Tracking Info"} />
      <Grid sx={{ padding: "10px 0 0 10px" }} container spacing={3}>
        <Grid item xs={12}>
          <Texts
            field={{ name: "custOrdNbr", value: form.custOrdNbr, label: "Cust Order Number" }}
            onChange={(e) => {
              let value = e.target.value.trim();
              const update = { custOrdNbr: value };
              setForm((prev) => ({ ...prev, ...update }));
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Texts
            field={{
              name: "trackingNumber",
              value: form.trackingNumber,
              label: "Tracking Number (split by comma)",
            }}
            onChange={(e) => {
              let value = e.target.value.trim();
              const update = { trackingNumber: value };
              setForm((prev) => ({ ...prev, ...update }));
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Texts
            field={{ name: "awbLink", value: form.awbLink, label: "AWB Link" }}
            onChange={(e) => {
              let value = e.target.value.trim();
              const update = { awbLink: value };
              setForm((prev) => ({ ...prev, ...update }));
            }}
          />
        </Grid>
      </Grid>
      <MDBox mt={2} width="100%" display="flex" justifyContent="center">
        <MDButton
          variant="gradient"
          color="info"
          onClick={() => {
            onSubmit();
          }}
          disabled={!canSubmit || editStatus}
        >
          Submit
        </MDButton>
      </MDBox>
    </Layout>
  );
}
export default EditTracking;
